import {
  HTTP_INTERCEPTORS,
  HttpClient,
  HttpClientModule,
} from '@angular/common/http';
import { isDevMode, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SharedModule } from './shared/shared.module';
import { ToastModule } from './shared/services/toast/toast.module';
import { TokenInterceptor } from './interceptors/token.interceptor';
import { LoginService } from '@app/login/login.service';
import { LocalStorageService } from '@app/shared/services/local-storage/local-storage.service';
import { AuthService } from '@app/shared/auth/auth.service';
import { ApiConfigService } from '@app/app.config';
import { ConfigService } from '@app/shared/auth/config.service';
import { CurrencyService } from '@app/shared/services/currency/currency.service';
import { CurrencyPipe, DecimalPipe } from '@angular/common';
import { CapitalizePipe } from '@app/shared/pipes/capitalize.pipe';
import { environment } from '@env/environment';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
import { DateService } from '@app/shared/services/date/date.service';

function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(
    http,
    environment.env !== 'local' ? '/app/assets/i18n/' : '/assets/i18n/'
  );
}

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserAnimationsModule,
    BrowserModule,
    HttpClientModule,
    SharedModule,
    AppRoutingModule,
    ToastModule.forRoot(),
    NgxDaterangepickerMd.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
  ],
  providers: [
    AuthService,
    LocalStorageService,
    ConfigService,
    ApiConfigService,
    LoginService,
    CurrencyService,
    CurrencyPipe,
    CapitalizePipe,
    DecimalPipe,
    DateService,
    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
    { provide: 'googleTagManagerId', useValue: environment.googleTagManagerId },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
